module.exports = __webpack_public_path__ + "static/media/check-mark-red.18dd044a.svg";